<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
          返回
        </el-button>
        <el-tab v-if="query.type_id == 1" style="font-size: 15px">热搜 - 添加内容</el-tab>
        <el-tab v-if="query.type_id == 2" style="font-size: 15px">课程 - 添加内容</el-tab>
        <el-tab v-if="query.type_id == 3" style="font-size: 15px">直播 - 添加内容</el-tab>
        <el-tab v-if="query.type_id == 4" style="font-size: 15px">心理咨询 - 添加咨询师</el-tab>
        <el-tab v-if="query.type_id == 5" style="font-size: 15px">商城 - 添加内容</el-tab>
      </el-col>
    </el-row>

    <el-row>
      <el-button type="primary" size="mini" @click="toCreate(0, '')" style="float: right">
        添加
      </el-button>
    </el-row>

    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column
            prop="id"
            label="ID"
            align="center"
            min-width="8%"
        ></el-table-column>
        <el-table-column
            v-if="query.type_id != 4"
            prop="name"
            label="推荐内容"
            align="center"
            min-width="57%"
        ></el-table-column>
        <el-table-column
            v-if="query.type_id == 4"
            prop="name"
            label="推荐咨询师"
            align="center"
            min-width="57%"
        ></el-table-column>
        <el-table-column
            prop="sort"
            label="排序"
            align="center"
            min-width="13%"
        >
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="setSort(row.id, row.sort)">
              {{ row.sort }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="28%">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="mini"
                :style="{color:row.status ==1?'red':'#409eff'}"
                @click="setUpDown(row)">{{ row.status == 1 ? '下架' : '上架' }}
            </el-button>

            <el-button
                v-if="row.search_type_id != 4"
                :disabled="row.status == 1"
                type="text"
                size="mini"
                @click="toCreate(row.id, row.name)"
            >
              编辑
            </el-button>

            <el-button
                type="text"
                size="small"
                :style="{color:'red'}"
                @click="deleteRelation(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <!--咨询师-->
    <el-dialog
        title="选择咨询师"
        :visible.sync="counselor.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="addEditFormOnCloseCounselor"
        width="75%"
    >
      <el-form :inline="true" :model="counselor.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
              size="small"
              v-model="counselor.query.search"
              placeholder="请输入标题或ID"
              clearable
              @blur="searchDataCounselor()"
          />
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              size="small"
              @click="
              searchDataCounselor();
            "
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
          border
          :data="counselor.result.data"
          highlight-current-row
          v-loading="counselor.listLoading1"
          style="..."
      >
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px" alt=""/>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="价格"
            align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectCounselor(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="searchDataCounselor"
          :current-page.sync="counselor.query.page"
          :page-size="counselor.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="counselor.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRelationList,
  addRelation,
  setUpDown,
  updateSort,
  delRelation,
  screenCounselorList
} from "@/api/searchRecommend";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        type_id: this.$route.query.id
      },

      counselor: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          search: "",
          page: 1,
          limit: 5,
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    this.query.type_id = this.$route.query.id;
    this.getList();
  },
  methods: {
    toCreate(id, remark) {
      // eslint-disable-next-line no-unused-vars
      var type_id
      type_id = this.query.type_id
      if (type_id == 4) {
        this.searchDataCounselor()
      } else {
        this.relationAdd(type_id, id ,remark)
      }
    },

    getList() {
      this.loading = true;
      console.log(this.query)
      getRelationList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    setUpDown(value) {
      // eslint-disable-next-line no-unused-vars
      var status;
      var message;
      if (value.status == 1) {
          if (value.search_type_id == 4) {
            status = '不推荐'
          } else {
            status = '下架'
          }
      } else {
          if (value.search_type_id == 4) {
            status = '推荐'
          } else {
            status = '上架'
          }
      }
      if (value.search_type_id == 4) {
        message = "是否确认" + status + "此咨询师？";
      } else {
        message = "是否确认" + status + "此内容?"
      }
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setUpDown({
          id: value.id,
          status: value.status == 1 ? 0 : 1
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: value.status == 1 ? '下架成功' : '上架成功',
              type: "success",
            });
          } else {
          }
        });
      });
    },

    deleteRelation(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delRelation({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
          }
        });
      });
    },

    setSort(id, remark) {
      this.$prompt("请输入排序（输入数字越大越靠前，0为无排序）", "排序", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: remark,
      }).then(({value}) => {
        updateSort({
          id: id,
          sort: value,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
            // eslint-disable-next-line no-empty
          } else {
          }
        });
      });
    },

    relationAdd(type_id, id, remark) {
      // eslint-disable-next-line no-unused-vars
      var text
      if (id > 0) {
        text = '编辑'
      } else {
        text = '添加'
      }
      this.$prompt("请输入推荐搜索内容", text + "推荐内容", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: remark,
      }).then(({value}) => {
        addRelation({
          id: id,
          search_type_id: type_id,
          name: value,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: id > 0 ? '修改成功' : '添加成功',
              type: "success",
            });
            // eslint-disable-next-line no-empty
          } else {
          }
        });
      });
    },

    // 咨询师 弹窗关闭
    addEditFormOnCloseCounselor() {
      this.counselor.query.page = 1;
      this.counselor.query.search = "";
      this.counselor.result = {
        total: 0,
        data: [],
      };
      this.counselor.chooseOrgVisible = false;
    },

    // 查询方法
    searchDataCounselor() {
      this.counselor.chooseOrgVisible = true;
      this.counselor.listLoading1 = true;
      screenCounselorList(this.counselor.query).then((response) => {
        this.counselor.result.data = response.data.list;
        this.counselor.result.total = response.data.total;
        this.counselor.listLoading1 = false;
      });
    },
    selectCounselor(row) {
      this.addEditFormOnCloseCounselor();
      this.counselor.chooseOrgVisible = false;
      addRelation({
        id: 0,
        search_type_id: this.query.type_id,
        target_id: row.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          // eslint-disable-next-line no-empty
        } else {
        }
      });
    },
  },
  mounted() {

  },
};
</script>